import { useUserPermissions } from "@/hooks";
import { ReactNode } from "react";

interface HasAllPermissionsProps {
  children: ReactNode;
  requiredPermissions: string[];
}

const HasAllPermissions = ({ children, requiredPermissions }: Readonly<HasAllPermissionsProps>) => {
  const { hasAllPermissions } = useUserPermissions();

  if (!hasAllPermissions(requiredPermissions)) {
    return null;
  }

  return children;
};

export default HasAllPermissions;
